import { render, staticRenderFns } from "./color_style.vue?vue&type=template&id=3e01c314&scoped=true"
import script from "./color_style.vue?vue&type=script&lang=js"
export * from "./color_style.vue?vue&type=script&lang=js"
import style0 from "./color_style.vue?vue&type=style&index=0&id=3e01c314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01c314",
  null
  
)

export default component.exports